import React, { useEffect, useState, useRef } from 'react';
import { FormControl } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import baseUrl from '../../config/config';
import GoogleMapsGet from '../../common/GoogleMap/GoogleMapsGet';

export default function PropertyLocation(props) {
    const [itemstype, setItemstype] = useState([]);
    const prevPropertyTypeId = useRef(null);
    useEffect(() => {
        fetch(`${baseUrl.baseUrl}get-property-type/`,
            {
                headers: {
                    "Authorization": `${process.env.REACT_APP_API_KEY}`,
                    'Accept-Encoding': 'gzip, deflate',
                }
            })
            .then(async response => {
                const result = await response.json()
                if (response.status === 201 || response.status === 200) {
                    setItemstype(result)
                }
                else if (response.status === 403) {
                    localStorage.setItem('access_token', '')
                }
            }
            )
            .catch((error) => {
                console.error('error message', error)
            })
    }, [])

    useEffect(() => {
        if (props.location === true) {
            if (
                (props.old_address === props.values.property_address.street_address) &&
                (prevPropertyTypeId.current !== null) && 
                (prevPropertyTypeId.current !== props.values.property_type_id)
            ) {
                props.handleReset();
            }

            prevPropertyTypeId.current = props.values.property_type_id;
        }
    }, [props.values.property_type_id, props.location]);

    return (
        <div className="form-question">
            <div className="form-content" >
                <h4 className="form-content-heading m-0">
                    Let’s start by locating your property
                </h4>
                <div className="form-content-field">
                    <div className="w-res-50 py-2">
                        <GoogleMapsGet submitResponse={props.submitResponse} handleLocationGet={props.handleLocationGet} addressDisable={props.addressDisable} handleReset={props.handleReset} handleChange={props.handleChange} values={props.values} errors={props.errors} validateDisplay18={props.validateDisplay18} location={props.location} setDisplayError={props.setDisplayError} />
                    </div>
                    <div className="w-res-50 py-2">
                        <FormControl variant="outlined" className="property-select w-100 py-1">
                            <select
                                name="property_type_id"
                                onChange={props.handleChange}
                                value={props.values.property_type_id ? props.values.property_type_id : 'Property Type'}
                                displayempty="true"
                                style={{ height: '54px', color: '#000' }}
                                inputprops={{ 'aria-label': 'Without label' }}
                            >
                                <option values="" disabled>Property Type</option>
                                {itemstype.map((item) => (
                                    <option key={item.property_type_id} value={item.property_type_id}  >
                                        {item.property_type}
                                    </option>
                                ))}
                            </select>
                            <div className="create">
                                {props.validateDisplay18 === "contentID" ? props.errors.property_type_id && props.errors.property_type_id ?
                                    <div className="error-msg">{props.errors.property_type_id}</div> : ''
                                    : ''}
                            </div>
                        </FormControl>
                    </div>
                </div>
            </div>
        </div>
    )
}
